import React from 'react';
import { styled } from '@mui/material/styles';
import { Field, reduxForm } from 'redux-form';
import Button from '@mui/material/Button';
import compose from 'recompose/compose';
import grey from '@mui/material/colors/grey';
import {
  syncCheckPasswordForm,
  shouldAsyncValidate,
  required,
  checkUsername
} from '../../services/validate';
import { trim } from '../../services/normalize';
import { RenderTextField } from '../../forms/renderFields';

const PREFIX = 'PasswordForm';

const classes = {
  buttonLine: `${PREFIX}-buttonLine`,
  buttomText: `${PREFIX}-buttomText`
};

const Root = styled('form')(() => ({
  [`& .${classes.buttonLine}`]: {
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'space-around'
  },

  [`& .${classes.buttomText}`]: {
    color: grey[500],
    marginTop: '1rem'
  }
}));

const PasswordForm = props => {
  const { handleSubmit, pristine, reset, submitting, error } = props;
  return (
    <Root onSubmit={handleSubmit}>
      <div>{error && <strong>{error}</strong>}</div>
      <div>
        <Field
          name="username"
          autoFocus
          component={RenderTextField}
          label="用户名"
          validate={[required, checkUsername]}
          normalize={trim}
        />
      </div>
      <div>
        <Field
          name="password"
          component={RenderTextField}
          type="password"
          validate={required}
          label="原密码"
        />
      </div>
      <div>
        <Field
          name="password1"
          component={RenderTextField}
          type="password"
          validate={required}
          label="新密码"
        />
      </div>
      <div>
        <Field
          name="password2"
          component={RenderTextField}
          type="password"
          validate={required}
          label="确认新密码"
        />
      </div>
      <div className={classes.buttonLine}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={pristine || submitting}
        >
          保存
        </Button>
        <Button
          variant="text"
          // color="second"
          onClick={reset}
          disabled={pristine || submitting}
        >
          清除
        </Button>
      </div>
    </Root>
  );
};

const enchance = compose(
  reduxForm({
    form: 'passwordForm',
    shouldAsyncValidate,
    validate: syncCheckPasswordForm
  })
);

export default enchance(PasswordForm);
